import React, { useState, useEffect, useRef } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Lastconsultation from "../../components/Dashboard/last_consultation";
import Upcoming from "../../components/Dashboard/upcoming";
import Recent from "../../components/Dashboard/recent";
import Favorite from "../../components/Dashboard/favorite";
import Reading from "../../components/Dashboard/reading";
import Hello from "../../components/Dashboard/hello";
import Balance from "../../components/Dashboard/balance";
import Goals from "../../components/Dashboard/goals";
import Spinner from "../../components/Spinner/spinner";
import Header from "../../components/header/header";
import axios from "axios";
import SpecialOfferModal from "../../pages/specialofferModal/specialoffer";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";
import { getStoredUserToken, getStoredToken } from "../../authService";
import Swal from "sweetalert2";

const baseUrl = process.env.REACT_APP_BASE_URL;
const Dashboard = ({ user, dashboard }) => {
   const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showSpecialOfferModal, setShowSpecialOfferModal] = useState(false);

  const [offer, setOffer] = useState(null);
  const [offers, setOffers] = useState([]);
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
  const [showOffer, setShowOffer] = useState(false);
  const offerShownRef = useRef(false);

  const [dash, setData] = useState({
    Lastconsultation: {},
    Reading: {},
    Favorite: {},
    appointments: [],
    messages: [],
    Balance: [],
    loyalty: {
      total_credits: 0,
      remaining_credits: 0,
      programs: [],
    },
    sponsorship: {},
    available_loyalty_rewards: [],
    available_sponsorship_rewards: [],
  });
    useEffect(() => {
      const defaultLang = process.env.REACT_APP_LANG;
      const cookieLang =
        localStorage.getItem("lang") ||
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("lang="))
          ?.split("=")[1] ||
        defaultLang;
  
      if (cookieLang) {
        import(`../../lang/dashboard/${cookieLang}.json`)
          .then((data) => {
            setLanguageData(data);
          })
          .catch((error) => {
            console.error("Error loading language file:", error);
          });
      } else {
        console.warn("Language cookie 'lang' not found.");
      }
    }, []);

  const renderReward = (reward) => {
  const currencyMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };

  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec)) return "00:00:00";

    const hrs = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const secs = String(sec % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };

  if (reward.type === "points") {
    return `
      <div class="mb-10">
        • <strong class="fs-17">+${reward.points} points</strong>
      </div>
    `;
  }

  if (reward.type === "discount") {
    const packageNames = reward.packages
      ?.map((pkg) => {
        const itemsText = pkg.items
          ?.map((item) => {
            const value =
              item.unit === "period"
                ? formatTime(item.size)
                : item.size;

            const label =
              item.service?.communication === "call"
                ? languageData.communication.call
                : item.service?.communication === "email"
                  ? "emails"
                  : "messages";

            return `${value} ${label}`;
          })
          .join(", ");

        return `${pkg.name} (${itemsText} - ${pkg.price}${currencyMap[pkg.currency]})`;
      })
      .join(" + ");

    return `
      <div class="mb-10 flex flex-column gap-2 fs-15">
        <strong class="fs-17">
          • ${parseFloat(reward.discounts?.value || 0)}% ${languageData.sponsorship_alert.discount}
        </strong>
        <p class="mb-0">${packageNames}</p>
        <p class="mb-0">
          ${languageData.sponsorship_alert.instead_of} <s>${reward.price}${currencyMap[reward.currency]}</s>,
           ${languageData.sponsorship_alert.pay_just} <strong>${reward.discounted_price}${currencyMap[reward.currency]}</strong>
        </p>
      </div>
    `;
  }

  if (reward.type === "package" || reward.type === "free_product") {
    const packages = reward.packages
      ?.map((pkg) => {
        const items = pkg.items
          ?.map((item) => {
            const value =
              item.unit === "period"
                ? formatTime(item.size)
                : item.size;

            const label =
              item.service?.communication === "call"
                ? languageData.communication.call
                : item.service?.communication === "email"
                  ? "emails"
                  : "messages";

            const icon =
              item.service?.communication === "call"
                ? `<i class="fa fa-phone"></i>`
                : item.service?.communication === "email"
                  ? `<i class="fa fa-envelope"></i>`
                  : "";

            return `${icon} ${value} ${label}`;
          })
          .join("<br>");

        return `
          <div class="flex flex-column mt-8">
            <strong>• ${pkg.name}</strong>
            <span>${items}</span>
          </div>
        `;
      })
      .join("");

    return `
      <div class="mb-10">
        ${packages}
      </div>
    `;
  }

  return "";
};
useEffect(() => {
  if (!languageData?.sponsorship_alert) return;

  const data = localStorage.getItem("signup_rewards_alert");
  if (!data) return;

  try {
    const parsed = JSON.parse(data);

    if (!parsed.show || !parsed.rewards?.length) return;

    const rewardsHtml = parsed.rewards
      .map((reward) => renderReward(reward))
      .join("");

    Swal.fire({
      icon: "success",
      title: languageData.sponsorship_alert.title,
      html: `
        <p class="mb-3">
          ${languageData.sponsorship_alert.subtitle}
        </p>
        <div class="flex flex-column">
          ${rewardsHtml}
        </div>
      `,
      confirmButtonText: "OK",
    }).then(() => {
      localStorage.removeItem("signup_rewards_alert");
    });
  } catch (e) {
    console.error(e);
    localStorage.removeItem("signup_rewards_alert");
  }
}, [languageData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setShowSpinner(true);

      const response = await api.get(`/accounts/dashboard`);

      setData({
        Lastconsultation: response.data.data.last_consultation,
        Reading: response.data.data.total_readings,
        Favorite: response.data.data.favorite_expert,
        messages: response.data.data.messages || [],
        appointments: response.data.data.appointments,
        balance: response.data.data.balance || [],
        loyalty: response.data.data.loyalty_gains,
        sponsorship: response.data.data.sponsorship_gains,
        available_loyalty_rewards:
          response.data.data.available_loyalty_rewards || [],
        available_sponsorship_rewards:
          response.data.data.available_sponsorship_rewards || [],
      });
    } catch (error) {
      console.error(error);
    } finally {
      setShowSpinner(false);
    }
  };
  /*   useEffect(() => {
    const fetchOffer = async () => {
      try {
        const response = await api.get(
          `/content/load?types[]=offers&types[]=credits`,
        );

         const allOffers = response?.data?.data?.offers || [];
       const availableOffers = allOffers.filter(
        (offer) =>
          !Cookies.get(`disableSpecialOfferAutoOpen_${offer.id}`)
      );

      if (!availableOffers.length) return;

       setOffers(availableOffers);
      setCurrentOfferIndex(0);
      setShowOffer(true);
      } catch (err) {
        console.log(err);
      }
    };

    fetchOffer();
  }, []); */
  const handleCloseOffer = () => {
    const nextIndex = currentOfferIndex + 1;

    if (nextIndex < offers.length) {
      setCurrentOfferIndex(nextIndex);
    } else {
      setShowOffer(false);
    }
  };
useEffect(() => {
  const handleRefresh = () => {
    fetchData(); // reload dashboard (includes balance)
  };

  window.addEventListener("refresh-dashboard", handleRefresh);

  return () => {
    window.removeEventListener("refresh-dashboard", handleRefresh);
  };
}, []);
  const handleRejectOffer = () => {
    const currentOffer = offers[currentOfferIndex];

    if (currentOffer) {
      Cookies.set(`disableSpecialOfferAutoOpen_${currentOffer.id}`, "1");
    }

    handleCloseOffer();
  };
  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div class="row m-0 text-start">
          <div className="col-xxl-9">
            <div className="row m-0">
              <Hello />
              <div class="col-xl-12">
                <div className="row m-0">
                  <Lastconsultation data={dash} />
                  <Reading data={dash} />
                  <Favorite data={dash} />
                </div>
              </div>

              <Upcoming data={dash} />
              <Recent data={dash} />
            </div>
          </div>

          <div className="col-xxl-3">
            <div className="row m-0">
              <Balance data={dash}  />
              <Goals data={dash} />
            </div>
          </div>
        </div>
      )}
      {/*    <Header messages={dash.messages} /> */}
      {/*       <SpecialOfferModal
        show={showOffer}
        onClose={handleCloseOffer}
        onReject={handleRejectOffer}
        offer={offers[currentOfferIndex]}
      /> */}
    </>
  );
};

export default Dashboard;
